import React, { PropsWithChildren } from 'react';

import classes from './Helpers.scss';

type BlockProps = Record<string, unknown>;

export function Block(props: PropsWithChildren<BlockProps>) {
    return <div className={classes.block}>{props.children}</div>;
}

export function BlockHalfSpacing(props: PropsWithChildren<BlockProps>) {
    return <div className={classes.blockHalfSpacing}>{props.children}</div>;
}

export function SpaceAbove(props: PropsWithChildren<BlockProps>) {
    if (React.Children.count(props.children) === 0) return null;
    return <div className={classes.spaceAbove}>{props.children}</div>;
}

export function AccountBlock(props: PropsWithChildren<BlockProps>) {
    return <section className={classes.accountBlock}>{props.children}</section>;
}
